import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="progress-container">
      {steps.map((step, index) => (
        <div className="step" key={index}>
          <div className={`circle ${index <= currentStep ? 'active' : ''}`}>{index + 1}</div>

          {index !== steps.length - 1 && (
            <div className={`progress-line ${index < currentStep ? 'active' : ''}`} />
          )}

          <p className="step-label">{step.title}</p>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
